import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * ResponsivesidebarService.
 * Provides a reactive service to manage the open/close state of a responsive sidebar across the application.
 */
@Injectable({
  providedIn: 'root'
})
export class ResponsivesidebarService {

  /** BehaviorSubject to track sidebar open state */
  private _isOpen = new BehaviorSubject<boolean>(false);
  /** Observable for sidebar open state */
  isOpen$ = this._isOpen.asObservable();

  /**
   * Toggles the sidebar open/close state.
   */
  toggle() {
    this._isOpen.next(!this._isOpen.value);
  }

  /**
   * Opens the sidebar.
   */
  open() {
    this._isOpen.next(true);
  }

  /**
   * Closes the sidebar.
   */
  close() {
    this._isOpen.next(false);
  }
}